module.exports = __webpack_public_path__ + "img/general-juanfe.32df857c.png";